import * as types from '../../index';

export const payLevelsListAction = (data) => {
    return {
    type: types.PAY_LEVELS_LIST,
    data
    }
};

export const payLevelsAddAction = (data) => {
    return {
    type: types.PAY_LEVELS_ADD,
    data
    }
};

export const payLevelsEditAction = (data) => {
    return {
    type: types.PAY_LEVELS_EDIT,
    data
    }
};

export const payLevelsUpdateAction = (data) => {
    return {
    type: types.PAY_LEVELS_UPDATE,
    data
    }
};

export const payLevelsDeleteAction = (data) => {
    return {
    type: types.PAY_LEVELS_DELETE,
    data
    }
};